import React from 'react';
import { components, DropdownIndicatorProps } from 'react-select';

import { Icons } from '@icons/icons';

type TDropdownIndicatorExtraProps = {
	isCloseMenuOnDropdownIndicatorClick?: boolean;
	onDropdownIndicatorToggleMenu?: () => void;
};

export const DropdownIndicator = (
	props: DropdownIndicatorProps & TDropdownIndicatorExtraProps,
) => {
	const menuIsOpen = props.selectProps.menuIsOpen;

	const handleMouseDown: React.MouseEventHandler = (event) => {
		if (!props.isCloseMenuOnDropdownIndicatorClick) {
			props.innerProps?.onMouseDown?.(event as any);

			return;
		}

		event.preventDefault();
		event.stopPropagation();

		props.onDropdownIndicatorToggleMenu?.();
	};

	return (
		<components.DropdownIndicator
			{...props}
			innerProps={{
				...props.innerProps,
				onMouseDown: handleMouseDown,
			}}
		>
			{menuIsOpen ? Icons.chevronUp() : Icons.chevronDown()}
		</components.DropdownIndicator>
	);
};
